<template>
  <main>

    <section v-if="page">
      <div class="o-wrapper">

        <article class="">
          <Title :content="page" />

          <div class="o-layout u-margin-top-small u-margin-bottom-small u-margin-bottom-none@tablet u-margin-top-none@tablet">
            <div class="o-layout__item u-1/2@tablet">
              <div class="c-splash-item">
                <router-link @click.native="setType('wholesale')" :to="getNextPage('Wholesale')">
                  <div class="c-splash-item__cover">
                    <span class="c-splash-item__overlay"></span>
                    <img class="c-splash-item__image" :src="page.wholesale.image.srcSet[0].url">
                  </div>
                  <Shape :link="true" type="pagetop" :img="page.wholesale.image" :imgOverlay="true" :bg="true" :id="Math.random().toString(36).substring(7)" />
                  <div class="c-splash-item__content">
                    <h3>{{ page.wholesale.title }}</h3>
                    <span class="c-btn c-btn--white is-active">
                      <span class="c-btn__arrow"></span>

                      {{ page.readMore }}

                      <span class="c-btn__hover">
                        <svg svg-inline="" focusable="false" role="presentation" width="241" height="14" viewBox="0 0 241 14" xmlns="http://www.w3.org/2000/svg"><path d="M0 1c36.44 10.083 65.748 11.382 85.864 10.68 50.429-1.762 80.135-17.316 112.864-5.401 16.93 6.163 31.798 9.014 38.397 4.54 1.709-1.158 3.555-3.723 2.626-6.154" stroke="#F0C57B" fill="none" fill-rule="evenodd"/></svg>
                      </span>
                    </span>
                  </div>
                </router-link>
              </div>
            </div>
            <div class="o-layout__item u-1/2@tablet">
              <div class="c-splash-item c-splash-item--last">
                <router-link @click.native="setType('retail')" :to="getNextPage('Retail')">
                  <div class="c-splash-item__cover">
                    <span class="c-splash-item__overlay"></span>
                    <img class="c-splash-item__image" :src="page.retail.image.srcSet[0].url">
                  </div>
                  <Shape :link="true" type="pagetop" :img="page.retail.image" :imgOverlay="true" :bg="true" :id="Math.random().toString(36).substring(7)" />
                  <div class="c-splash-item__content">
                    <h3>{{ page.retail.title }}</h3>
                    <span class="c-btn c-btn--white">
                      <span class="c-btn__arrow"></span>

                      {{ page.readMore }}

                      <span class="c-btn__hover">
                        <svg svg-inline="" focusable="false" role="presentation" width="241" height="14" viewBox="0 0 241 14" xmlns="http://www.w3.org/2000/svg"><path d="M0 1c36.44 10.083 65.748 11.382 85.864 10.68 50.429-1.762 80.135-17.316 112.864-5.401 16.93 6.163 31.798 9.014 38.397 4.54 1.709-1.158 3.555-3.723 2.626-6.154" stroke="#F0C57B" fill="none" fill-rule="evenodd"/></svg>
                      </span>
                    </span>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </article>

      </div>
    </section>

  </main>
</template>

<script>
import { mapState } from 'vuex'
import anime from 'animejs'
import Shape from '@/components/Shape'
import Button from '@/components/Button'
import Title from '@/components/content/Title'

export default {
  name: 'Home',

  data () {
    return {
    }
  },

  beforeMount () {
    const lang = this.$route.params.lang
    const _this = this
    this.$store.dispatch('getSingle', { slug: 'home', lang: lang }).then((result) => {
      _this.resetAnim()
    })
  },

  beforeRouteLeave (to, from, next) {
    this.getPageWrapper(to, from, next)
  },

  beforeRouteUpdate (to, from, next) {
    this.getPageWrapper(to, from, next)
  },

  methods: {
    getPageWrapper (to, from, next) {
      const _this = this
      // const target = document.querySelector('.c-bg-anim')
      anime({
        targets: '.c-bg-anim',
        duration: 800,
        translateX: window.innerWidth <= 768 ? '-95%' : '-20%',
        rotate: -20,
        easing: 'easeInQuad',
        complete: function (anim) {
          if (to.name === 'Home') {
            _this.getPage(to)
          }
        }
      })

      setTimeout(() => {
        next()
      }, 800)
    },

    getPage (route) {
      const lang = route.params.lang
      const _this = this
      this.$store.dispatch('getSingle', { slug: 'home', lang: lang }).then((result) => {
        _this.resetAnim()
      })
    },

    resetAnim () {
      anime({
        targets: '.c-bg-anim',
        duration: 800,
        translateX: '110%',
        rotate: -20,
        easing: 'easeInQuad'
      })
    },

    getNextPage (type) {
      if (this.redirectPage !== '/en' && this.redirectPage !== '/nl' && this.redirectPage !== '/en/' && this.redirectPage !== '/nl/' && this.redirectPage !== '/fr' && this.redirectPage !== '/fr/' && this.redirectPage !== null) {
        return this.redirectPage
      } else {
        if (type === 'Retail') {
          return { name: 'Retail' }
        } else {
          if (this.$route.params.lang === 'nl') {
            return { name: 'WholesaleNL' }
          } else if (this.$route.params.lang === 'fr') {
            return { name: 'WholesaleFR' }
          } else return { name: 'Wholesale' }
        }
      }
    },

    setType (type) {
      this.$store.commit('setType', { type: type })
      this.$store.commit('setRedirectPage', { slug: null })

      document.cookie = 'splashOption=' + type + '; path=/'
      var oReq = new XMLHttpRequest()
      oReq.open('GET', '/api/globals?lang=en')
      oReq.send()
    }
  },

  computed: {
    seo () {
      return this.$store.state.seo[this.path]
    },

    ...mapState({
      path: state => state.seo.path,
      page: state => state.page.splashpage,
      type: state => state.type,
      redirectPage: state => state.redirectPage
    })
  },

  components: {
    Shape,
    Title,
    Button
  },

  metaInfo () {
    return {
      title: this.seo.title,
      meta: [
        { property: 'og:title', content: this.seo.ogTitle },
        { property: 'twitter:title', content: this.seo.twitterTitle },
        { name: 'description', content: this.seo.description },
        { property: 'og:description', content: this.seo.ogDescription },
        { property: 'twitter:description', content: this.seo.twitterDescription },
        { property: 'og:image', content: this.seo.ogImage },
        { property: 'twitter:image', content: this.seo.twitterImage }
      ]
    }
  }
}
</script>
